<template>
  <div class="accountMar">
  <el-card class="box-card">
    <div slot="header" class="clearfix">
      <el-button style="float: left;" type="success" @click="addAccount">新增账户</el-button>
      <span style="line-height: 36px;">账户管理</span>
      <div style="float:right">
        <el-input placeholder="联系人/账号/账号状态" v-model="searchValue" @keyup.enter.native="btnQueryAccountByKey">
          <el-select v-model="searchSelect" slot="prepend" placeholder="请选择">
            <el-option label="全部" value="-1"></el-option>
            <el-option label="联系人" value="0"></el-option>
            <el-option label="联系人账号" value="1"></el-option>
            <el-option label="设备主" value="2"></el-option>
            <el-option label="运维" value="3"></el-option>
            <el-option label="商户" value="4"></el-option>
            <el-option label="销售" value="5"></el-option>
          </el-select>
          <el-button slot="append" icon="search" @click="btnQueryAccountByKey"></el-button>
        </el-input>
      </div>
    </div>
    <div>
      <el-table
      v-loading="table_loading"
      element-loading-text="拼命加载中"
      :data="tableData"
      stripe
      border
      fit
      style="width: 100%">
      <el-table-column
        prop="userNum"
        header-align="center"
        width="70"
        label="编号">
      </el-table-column>
      <el-table-column
        prop="userName"
        header-align="center"
        min-width="130"
        label="联系人">
      </el-table-column>
      <el-table-column
        prop="adminName"
        header-align="center"
        min-width="95"
        label="账号类型">
      </el-table-column>
      <el-table-column
        prop="userPhone"
        header-align="center"
        min-width="130"
        label="联系电话">
      </el-table-column>
      <el-table-column
        prop="userLogin"
        header-align="center"
        min-width="125"
        label="登录账号">
      </el-table-column>
      <el-table-column
        prop="userStatus"
        header-align="center"
        min-width="95"
        label="账号状态">
      </el-table-column>

      <el-table-column
       v-if="getAuthorityFxShop()==true"
        prop="userStatus"
        header-align="center"
        min-width="95"
        label="分润金额">
         <template scope="scope">
          {{scope.row.shareFee/100}}
         </template>
      </el-table-column>
      <el-table-column
        v-if="getAuthorityFxShop()==true"
        prop="money"
        header-align="center"
        min-width="95"
        label="余额">
      </el-table-column>
      <el-table-column
        v-if="getAuthorityFxShop()==true"
        prop="levelName"
        header-align="center"
        min-width="95"
        label="等级">
      </el-table-column>
      <el-table-column
        prop="userSetting"
        header-align="center"
        min-width="300"
        label="操作">
        <template scope="scope">
          <el-button
            @click.native.prevent="upDateUserName(tableData[scope.$index])"
            type="text" size="small">
            编辑
          </el-button>
          <el-button
            @click.native.prevent="upDateUserPwd(scope.row.userNum)"
            type="text" size="small">修改密码</el-button>
          <el-button type="text" size="small"
            @click="lookAcc(scope.row.userNum, scope.row.userName, scope.row.userPhone, scope.row.user_type)">查看设备</el-button>


            <el-button v-show="userType == 0" type="text" size="small"
              @click="enterBackStage(scope.row.userType,scope.row.userLogin,scope.row.userPwd)">进入后台</el-button>

          <el-button v-show="getAuthorityFxShop()==true" type="text" size="small"
            @click="modifyBalance(tableData[scope.$index])">修改余额</el-button>

          <el-button v-show="getAuthorityFxShop()==true" type="text" size="small"
              @click.native.prevent="modifyLevel(scope.row.userNum)">调整等级</el-button>


          <el-button v-show="getAuthorityFxShop()==true" type="text" size="small"
              @click.native.prevent="modifyFxFee(scope.row.userNum,scope.row.shareFee)">设置分润</el-button>



          <el-button v-show="getAuthorityNoFlow()==false&&getAuthorityUserNoFlow(scope.row.showPage)==true" type="text" size="small"
                  @click.native.prevent="modifyNoFlow(scope.row.userNum, scope.row.showPage, 0)">允许改流程</el-button>

          <el-button v-show="getAuthorityNoFlow()==false&&getAuthorityUserNoFlow(scope.row.showPage)==false" type="text" size="small"
                  @click.native.prevent="modifyNoFlow(scope.row.userNum, scope.row.showPage, 1)">禁止改流程</el-button>

          <el-button v-show="getAuthorityNoFlow()==false" type="text" size="small"
                          @click.native.prevent="addUserFlow(scope.row.userNum)">增加用户流程</el-button>

          <el-button
            @click.native.prevent="deleteAccount(tableData[scope.$index].userNum)"
            style="color: #FF4949" type="text" size="small">销户</el-button>


        </template>
      </el-table-column>
    </el-table>
    </div>
    <div class="table_pagination">
      <el-pagination
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :current-page="pageNo"
        :page-sizes="[10, 20, 50, 100]"
        :page-size="pageSize"
        layout="total, sizes, prev, pager, next, jumper"
        :total="pageTotal">
      </el-pagination>
    </div>
  </el-card>
  <transition name=".el-fade-in-linear">
    <pu-add-account :add-show="addAccountShow" @closeAddAccount="closeAddAccountBox"></pu-add-account>
  </transition>

  <pu-update-pwd :update-pwd-show='updatePwdShow' :the-id="userNum" @closeUpdatePwd="closeUpdatePwd"></pu-update-pwd>
  <pu-update-level :update-level-show='updateLevelShow' :the-id="userNum" @closeUpdateLevel="closeUpdateLevel"></pu-update-level>

  <pu-update-fxfee :update-fxfee-show='updateFxfeeShow' :the-id="userNum" :share-fee-props="shareFee" @closeUpdateFxfee="closeUpdateFxfee"></pu-update-fxfee>
  </div>
</template>

 <script>
    import $axios from '../../https/config'
    import puAddAccount from '@/page/accountMgr/addAccount'
    import puUpdatePwd from '@/page/accountMgr/updatePwd'
    import puUpdateLevel from '@/page/accountMgr/updateLevel'
    import puUpdateFxfee from '@/page/accountMgr/updateFxfee'
    import {isNull, getAuthority} from '../../js/tool'

    export default {
      data () {
        return {
          tableData: [],
          pageTotal: 0,
          pageSize: 10,
          pageNo: 1,
          userType: this.$store.state.userType,
          adminName:'',
          table_loading: false,
          addAccountShow: false,
          updatePwdShow: false,
          updateLevelShow: false,
          updateFxfeeShow: false,
          userNum: '',
          searchValue: '',
          searchSelect: '-1',
          shareFee:0
        }
      },
      created: function () {
        this.pageNo = 1
        this.queryAccountList()
      },
      methods: {
        getAuthorityFxShop () {
          return getAuthority("fxShop")
        },
        getAuthorityNoFlow () {
          return getAuthority("noFlow")
        },
        getAuthorityUserNoFlow (showPage) {
          if (isNull(showPage)){
            return false
          }
          if (showPage.indexOf('noFlow')>-1){
            return true
          }else{
            return false
          }
        },
        modifyNoFlow (userId, showPage, status) {
          var _this = this
          if (status==0) {
            showPage = showPage.replace("noFlow" , "")
          }else{
            if (isNull(showPage)){
              showPage = "noFlow"
            }else{
              showPage = showPage+",noFlow"
            }
          }
          var params = {
            id: userId,
            showPage: showPage
          }


          _this.$confirm('是否启动/禁用修改流程', '确认', {
            confirmButtonText: '确定',
            cancelButtonText: '取消',
            type: 'warning'
          }).then(() => {
            _this.table_loading = true
            $axios.post('/custom/editShowPage', params, 'headers', function (res) {
              if (res && res.resultStatus === true) {
                if (res.resultStatus) {
                  _this.$message({
                    type: 'success',
                    message: '修改成功!'
                  })
                  if (_this.searchSelect === '-1') {
                    _this.queryAccountList()
                  } else {
                    _this.queryAccountByKeyword(_this.searchSelect, _this.searchValue, _this.pageNo, _this.pageSize)
                  }
                } else {
                  _this.$message({
                    message: '修改失败!',
                    type: 'error'
                  })
                }
              } else {
              }
              _this.table_loading = false
            }, function () {})

          }).catch(() => {
            that.$message({
              type: 'info',
              message: '已取消'
            })
          })


        },
        modifyBalance (itemData) {
          this.$prompt('请输入修改后的余额', '是否修改用户‘' + itemData.userName + '’的余额', {
            confirmButtonText: '确定',
            cancelButtonText: '取消',
            showInput: true,
            inputValue: itemData.money,
            inputPlaceholder: '请输入用户新的余额',
            inputValidator: this.validateNumber,
            inputErrorMessage: '请输入数字'
          }).then(({ value }) => {
            var _this = this
            var params = {
              id: itemData.userNum,
              money: value*100
            }
            var url = '/custom/editUserMoney'
            $axios.post(url, params, 'headers', function (res) {
              if (res.resultStatus) {
                _this.$message({
                  type: 'success',
                  message: '余额修改成功!'
                })
                if (_this.searchSelect === '-1') {
                  _this.queryAccountList()
                } else {
                  _this.queryAccountByKeyword(_this.searchSelect, _this.searchValue, _this.pageNo, _this.pageSize)
                }
              } else {
                _this.$message({
                  message: '联系人名称修改失败!',
                  type: 'error'
                })
              }
            }, function (err) {
              _this.table_loading = false
              _this.$message({
                type: 'error',
                duration: 1000 * 5,
                message: '服务器异常，请稍后再试!' + err
              })
            })
          }).catch(() => {
            this.$message({
              type: 'info',
              message: '取消输入'
            })
          })
        },
        addUserFlow (userId) {
          var _this = this

          var params = {
            userId: userId
          }

          _this.$confirm('是否增加一个用户流程，增加后，可以在全局配置-用户例外流程修改和删除', '确认', {
            confirmButtonText: '确定',
            cancelButtonText: '取消',
            type: 'warning'
          }).then(() => {
            _this.table_loading = true
            $axios.get('/userChargeConfig/addUserConfig', params, 'headers', function (res) {
              if (res && res.resultStatus === true) {
                if (res.resultStatus) {
                  _this.$message({
                    type: 'success',
                    message: '增加成功!'
                  })
                } else {
                  _this.$message({
                    message: '增加失败!',
                    type: 'error'
                  })
                }
              } else {
              }
              _this.table_loading = false
            }, function () {})

          }).catch(() => {
            that.$message({
              type: 'info',
              message: '已取消'
            })
          })


        },
        modifyLevel (userNum) {
          this.userNum = userNum
          this.updateLevelShow = true
        },

        modifyFxFee (userNum,shareFee) {
          this.userNum = userNum

          console.log("shareFee="+shareFee);
          this.shareFee = shareFee/100
          this.updateFxfeeShow = true
        },
        queryAccountList () {
          var _this = this
          var params = {
            pageNo: _this.pageNo,
            pageSize: _this.pageSize
          }
          this.table_loading = true
          this.tableData = []
          $axios.get('/custom/getList', params, 'headers', function (res) {
            if (res && res.resultStatus === true) {
              var resData = []
              if (res.resultData && res.resultData.list.length > 0) {
                _this.pageTotal = res.resultData.count
                for (var i = 0; i < res.resultData.list.length; i++) {
                  var itemData = res.resultData.list[i]
                  var mType
                  var adminName
                  if (itemData.user_type === 0) {
                    mType = '超级管理员'
                    adminName = '超级管理员'
                  } else if (itemData.user_type === 1) {
                    mType = '代理商'
                    adminName = '管理员'
                  } else if (itemData.user_type === 2) {
                    mType = '设备主'
                    adminName = '管理员'
                  } else if (itemData.user_type === 3) {
                    mType = '维护人员'
                    adminName = '维护人员'
                  } else if (itemData.user_type === 4) {
                    mType = '商户'
                    adminName = '商户'
                  } else if (itemData.user_type === 5) {
                    mType = '销售'
                    adminName = '销售'
                  }
                  var item = {
                    userNum: itemData.id,
                    userType: mType,
                    adminName:adminName,
                    userName: itemData.nickName,
                    userPhone: itemData.user_name,
                    userLogin: itemData.user_name,
                    userPwd: itemData.password,
                    userStatus: itemData.status === 0 ? '正常' : '销户',
                    user_type: itemData.user_type,
                    money: itemData.money/100,
                    levelName: isNull(itemData.levelName)? '普通用户' : itemData.levelName,
                    showPage: itemData.showPage,
                    shareFee: itemData.shareFee,
                  }
                  resData.push(item)
                }
                _this.tableData = resData
              }
            } else {
            }
            _this.table_loading = false
          }, function () {})
        },
        btnQueryAccountByKey () {
          this.pageNo = 1
          if (this.searchSelect === '-1') {
            this.queryAccountList()
          } else {
            this.queryAccountByKeyword(this.searchSelect, this.searchValue, this.pageNo, this.pageSize)
          }
        },
        queryAccountByKeyword (tType, tKeyWord, tPageNo, tPageSize) {
          var _this = this
          var params = {
            type: tType,
            keyword: tKeyWord,
            pageNo: tPageNo,
            pageSize: tPageSize
          }
          this.table_loading = true
          this.tableData = []
          $axios.get('/device/queryAccount', params, 'headers', function (res) {
            if (res && res.resultStatus === true) {
              var resData = []
              if (res.resultData && res.resultData.list.length > 0) {
                _this.pageTotal = res.resultData.count
                for (var i = 0; i < res.resultData.list.length; i++) {
                  var itemData = res.resultData.list[i]
                  var mType
                  var adminName
                  if (itemData.user_type === 0) {
                    mType = '超级管理员'
                    adminName = '超级管理员'
                  } else if (itemData.user_type === 1) {
                    mType = '代理商'
                    adminName = '管理员'
                  } else if (itemData.user_type === 2) {
                    mType = '设备主'
                    adminName = '管理员'
                  } else if (itemData.user_type === 3) {
                    mType = '维护人员'
                    adminName = '维护人员'
                  } else if (itemData.user_type === 4) {
                    mType = '商户'
                    adminName = '商户'
                  } else if (itemData.user_type === 5) {
                    mType = '销售'
                    adminName = '销售'
                  }
                  var item = {
                    userNum: itemData.id,
                    userType: mType,
                    adminName:adminName,
                    userName: itemData.nickName,
                    userPhone: itemData.user_name,
                    userLogin: itemData.user_name,
                    userPwd: itemData.password,
                    userStatus: itemData.status === 0 ? '正常' : '销户',
                    user_type: itemData.user_type,
                    shareFee: itemData.shareFee,
                  }
                  resData.push(item)
                }
                _this.tableData = resData
              }
            } else {
            }
            _this.table_loading = false
          }, function () {})
        },
        handleSizeChange (val) {
          this.pageSize = val
          if (this.searchSelect === '-1') {
            this.queryAccountList()
          } else {
            this.queryAccountByKeyword(this.searchSelect, this.searchValue, this.pageNo, this.pageSize)
          }
        },
        handleCurrentChange (val) {
          this.pageNo = val
          if (this.searchSelect === '-1') {
            this.queryAccountList()
          } else {
            this.queryAccountByKeyword(this.searchSelect, this.searchValue, this.pageNo, this.pageSize)
          }
        },
        lookAcc (id, name, tel, type) {
          this.$router.push({path: '../deviceInfo/lookAccount', query: {'id': id, 'name': name, 'tel': tel, 'type': type}})
        },
        addAccount () {
          this.addAccountShow = true
        },
        closeAddAccountBox (v) {
          this.addAccountShow = false
          if (this.searchSelect === '-1') {
            this.queryAccountList()
          } else {
            this.queryAccountByKeyword(this.searchSelect, this.searchValue, this.pageNo, this.pageSize)
          }
        },
        deleteAccount (mAccountId) {
          this.$confirm('此操作将永久删除该用户, 是否继续?', '提示', {
            confirmButtonText: '确定',
            cancelButtonText: '取消',
            type: 'error',
            beforeClose: (action, instance, done) => {
              if (action === 'confirm') {
                var _this = this
                var params = {
                  id: mAccountId,
                  status: 1
                }
                var url = '/custom/closeAccount'
                $axios.post(url, params, 'headers', function (res) {
                  done()
                  if (res.resultStatus) {
                    _this.$message({
                      type: 'success',
                      message: '编号为' + mAccountId + '的账号删除成功!'
                    })
                    if (_this.searchSelect === '-1') {
                      _this.queryAccountList()
                    } else {
                      _this.queryAccountByKeyword(_this.searchSelect, _this.searchValue, _this.pageNo, _this.pageSize)
                    }
                  } else {
                    _this.$message({
                      message: '账号删除失败！' + res.errorMessage,
                      type: 'error'
                    })
                  }
                }, function (err) {
                  done()
                  _this.loading = false
                  _this.$message({
                    type: 'error',
                    duration: 1000 * 5,
                    message: '服务器异常，请稍后再试!' + err
                  })
                })
              } else {
                done()
              }
            }
          }).then(() => {
          }).catch(() => {
            this.loading = false
            this.$message({
              type: 'info',
              message: '已取消删除'
            })
          })
        },
        upDateUserName (itemData) {
          this.$prompt('请输入新的联系人名称', '是否修改编号为‘' + itemData.userNum + '’的联系人名称', {
            confirmButtonText: '确定',
            cancelButtonText: '取消',
            showInput: true,
            inputValue: itemData.userName,
            inputPlaceholder: '请输入联系人姓名',
            inputValidator: this.validateNickName,
            inputErrorMessage: '请输入2-8个字符'
          }).then(({ value }) => {
            var _this = this
            var params = {
              id: itemData.userNum,
              nickName: value
            }
            var url = '/custom/editUserInfo'
            $axios.post(url, params, 'headers', function (res) {
              if (res.resultStatus) {
                _this.$message({
                  type: 'success',
                  message: '联系人名称修改成功!'
                })
                if (_this.searchSelect === '-1') {
                  _this.queryAccountList()
                } else {
                  _this.queryAccountByKeyword(_this.searchSelect, _this.searchValue, _this.pageNo, _this.pageSize)
                }
              } else {
                _this.$message({
                  message: '联系人名称修改失败!',
                  type: 'error'
                })
              }
            }, function (err) {
              _this.loading = false
              _this.$message({
                type: 'error',
                duration: 1000 * 5,
                message: '服务器异常，请稍后再试!' + err
              })
            })
          }).catch(() => {
            this.$message({
              type: 'info',
              message: '取消输入'
            })
          })
        },
        enterBackStage (userType, userLogin, userPwd) {
          if (userType === '设备主' || userType === '超级管理员' || userType === '管理员' || userType === '代理商') {
            window.open('/#/login?user=' + userLogin + '&pwd=' + userPwd)
          } else {
            this.$message({
              message: '权限不足！不能登录设备管理后台',
              type: 'error'
            })
          }
        },
        upDateUserPwd (userNum) {
          this.userNum = userNum
          this.updatePwdShow = true
        },
        closeUpdatePwd (v) {
          this.updatePwdShow = false
          if (this.searchSelect === '-1') {
            this.queryAccountList()
          } else {
            this.queryAccountByKeyword(this.searchSelect, this.searchValue, this.pageNo, this.pageSize)
          }
        },
        closeUpdateLevel (v) {
          this.updateLevelShow = false
          if (this.searchSelect === '-1') {
            this.queryAccountList()
          } else {
            this.queryAccountByKeyword(this.searchSelect, this.searchValue, this.pageNo, this.pageSize)
          }
        },
        closeUpdateFxfee (v) {
          this.updateFxfeeShow = false
          if (this.searchSelect === '-1') {
            this.queryAccountList()
          } else {
            this.queryAccountByKeyword(this.searchSelect, this.searchValue, this.pageNo, this.pageSize)
          }
        },
        validateNickName (value) {
          if (value.length < 2 || value.length > 8) {
            return false
          }
        },
        validateNumber (value) {
          var reg = /^\d+(\.\d+)?$/;
          if (!reg.test(value)) {
            return false;
          }
        }
      },
      components: {
        'pu-add-account': puAddAccount,
        'pu-update-pwd': puUpdatePwd,
        'pu-update-level': puUpdateLevel,
        'pu-update-fxfee': puUpdateFxfee
      }
    }
  </script>

  <style lang="scss">
    .table_pagination {
      text-align: right;
      margin-top: 10px;
    }
    .accountMar {
      .el-select .el-input {
        width: 110px;
      }
    }
  </style>



// WEBPACK FOOTER //
// src/page/accountMgr/index.vue